import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, border } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { InfoText, InfoType } from '../General/InfoText';
import { CheckBox } from '../General/Checkbox';
import { Input } from '../General/Input';
import { FormInput } from '../Form/FormInput';
import { getDeliveryAddressInfo } from '../../../utilities/selectors';

interface Props {
  address: any;
  active?: boolean;
  onClick: (id) => void;
}

function AddressBlock({ onClick, address, active = false }: Props) {
  const {
    deliveryStreet,
    deliveryNumber,
    deliveryZip,
    deliveryCity,
    country,
    id,
    isDefault,
  } = getDeliveryAddressInfo(address);
  return (
    // tslint:disable-next-line:jsx-no-lambda
    <Wrapper active={active} onClick={() => onClick(id)}>
      <Street>{`${deliveryStreet} ${deliveryNumber}`}</Street>
      <CityCountryWrapper>
        <Text>{`${deliveryCity} ${deliveryZip}`}</Text>
        <Text>{country}</Text>
      </CityCountryWrapper>
      <CheckBox
        rounded={true}
        selected={isDefault}
        label={__('Predvolená adresa')}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ active: boolean }>`
  padding: ${rem(24)};
  border: ${({ theme, active }) =>
    active ? theme.borders.active : theme.borders.secondary};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  border-radius: ${rem(4)};
  max-width: ${rem(328)};
  margin-bottom: ${rem(32)};
  margin-right: ${rem(32)};
  transition: border 0.2s ease;
  width: 100%;
  cursor: pointer;
  height: ${rem(176)};

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
  `}
`;

const Text = styled(TextP)`
  font-weight: 300;
`;

const Street = styled(Text)`
  font-weight: 400;
`;

const CityCountryWrapper = styled(FlexCol)`
  margin: ${rem(16)} 0 ${rem(24)};
`;

export { AddressBlock };
